import React from "react";
import "./style.scss";

const LoginContainer = ({ children }) => {
  return (
    <div className="custom-login-container">
      {children}
    </div>
  );
};

export default LoginContainer;
